module.exports = {

  dashboard_port: 8500,

  dashboard_domain: "https://xstudio.aralego.com",

  dashboard_backstage_domain: "https://xstudio-admin.aralego.com",

  //api config

  api_server_port: 5000,

  api_server_domain: "https://xstudio-apis.aralego.com",

  api_server_secret: "Rich Media QAQQQQQQQQ",

  //user server

  user_auth_domain: "https://auth.aralego.com",

  //new user server

  new_user_server_domain: "https://auth2.aralego.com",

  user_server_auth: "https://xstudio.aralego.com/api/v1/test",

  //kernel

  ad_server_domain: "https://uts.aralego.com",

  //db config

  dbhost_RICHMEDIA:

    "sspdb1.aralego.com:27017,sspdb6.aralego.com:27017",

  dboptions: {

    autoReconnect: true,

    bufferMaxEntries: -1,

    readPreference: "nearest",

    replicaSet: "rs1",

    connectTimeoutMS: 360000,

    socketTimeoutMS: 360000,

    useNewUrlParser: true,

  },

  host_SSP:

    "sspdb1.aralego.com:27017,sspdb6.aralego.com:27017",

  host_DSP:

    "sspdb1.aralego.com:27017,sspdb6.aralego.com:27017",

  host_RTB: "10.28.5.26:27067,10.28.5.27:27067",

  opts_Native_Mongo: {

    replicaSet: "rs1",

    autoReconnect: true,

    bufferMaxEntries: -1,

    readPreference: "nearest",

    useNewUrlParser: true,

  },

  opts_SSP_Mongoose: {

    replicaSet: "rs1",

    poolSize: 5,

    readPreference: "nearest",

    useNewUrlParser: true,

  },

  opts_Mongoose: {

    replicaSet: "rs1",

    poolSize: 5,

    readPreference: "nearest",

    useNewUrlParser: true,

  },

  opts_Mongoose_DSP: {

    poolSize: 5,

    readPreference: "nearest",

    replicaSet: "rs1",

    useNewUrlParser: true,

  },

  opts_RTB_Mongoose: {

    replicaSet: "rs1",

    useNewUrlParser: true,

  },

  druid_endpoint: "http://report2.aralego.com",

  //session redis config

  REDIS_CLUSTER: [

    {

      host: '10.28.5.10',

      port: 8001

    },{

      host: '10.28.5.19',

      port: 8001

    },{

      host: '10.28.5.26',

      port: 8001

    },{

      host: '10.28.5.27',

      port: 8001

    },{

      host: '10.28.5.18',

      port: 8001

    },{

      host: '10.28.5.19',

      port: 8003

    }

  ],

  REDIS_CLUSTER_OPTIONS: {

    scaleReads: "all",

    showFriendlyErrorStack: true,

  },

  sessionSecret: "5566XXXXCAT5566XXXXGAYFORXMEN",

  cookieSecret: "5566XXXXCAT5566XXXXGAYFORXMEN",

  dmp_endpoint: "https://dm.aralego.com",

  ima_endpoint: "https://cdn.aralego.net/ima/v2",

  //cdn config

  cdn_host: "139.162.22.189",

  cdn_account: "dashboard_deploy",

  cdn_passwd: "2WsxzaQ1",

  cdn_directory: "/var/www/html/rich_media",

  cdn_url: "https://cdn.aralego.net/rich_media/",
};